import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { rem, darken } from 'polished';
import { IconAlert } from '../../layout/icons';

/**
 * The Top Menu button
 * @param {*} props
 */
const MenuButton = props => {
	const renderIconAlert = () => {
		if (props.hasIconAlert) {
			return (
				<div className="alert-icon">
					<IconAlert bgColor="white" invertColors={true} />
				</div>
			);
		}
		return null;
	};
	return (
		<Wrapper className={`menu-button`}>
			<button onClick={props.onClick}>
				<span className={`hamburguer hamburguer-icon ${props.className}`}>
					<span className="icon" />
				</span>
				{renderIconAlert()}
			</button>
		</Wrapper>
	);
};
const alertScaleIn = keyframes`
  0% {
    transform:scale(0);
  }
	85%{
		transform:scale(1.15);
	}
  100% {
    transform:scale(1);
  }
`;

const Wrapper = styled.div`
	width: ${props => rem(`${props.theme.navbarHeightSmall}`)};
	height: ${props => rem(`${props.theme.navbarHeightSmall}`)};
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	position: relative;
	cursor: pointer;
	.alert-icon {
		position: absolute;
		bottom: 0;
		right: 6px;

		transform: scale(0);
		animation-name: ${alertScaleIn};
		animation-delay: 1100ms;
		animation-duration: 300ms;
		animation-timing-function: ease-out;
		animation-fill-mode: forwards;
	}

	button {
		width: ${props => rem(`${props.theme.navbarHeightSmall}`)};
		height: ${props => rem(`${props.theme.navbarHeightSmall}`)};
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		background: transparent;
		border: none;

		&:focus {
			outline: none;
		}

		&:active {
			background-color: ${darken(0.1, `#346aea`)};
		}
	}

	.hamburguer {
		width: ${rem('22px')};
		height: ${rem('18px')};
		border: none;
		background: transparent;
		position: relative;
		cursor: pointer;
		display: block;
		user-select: none;
		&:focus {
			outline: none;
		}
		&.hamburguer-icon {
			// Top, bottom and center lines
			&:after,
			&:before,
			span {
				width: 100%;
				height: ${rem('2px')};
				border-radius: ${rem('2px')};
				position: absolute;
				left: 0;
				right: 0;
				display: block;
				background: ${props => props.theme.white};
			}
			// top and bottom lines
			&:after,
			&:before {
				content: '';
				transition: 300ms width 400ms;
			}
			// Top line
			&:after {
				top: 0;
				left: 0;
				margin-top: 0;
			}
			// Bottom Line
			&:before {
				bottom: 0;
				right: 0;
				margin-bottom: 0;
			}
			// Center line
			span {
				top: 50%;
				margin-top: -${rem('1px')};
				transition: transform 300ms;
				&:before {
					content: '';
					background: ${props => props.theme.white};
					width: 100%;
					height: ${rem('2px')};
					border-radius: ${rem('2px')};
					position: absolute;
					left: 0;
					transition: transform 300ms;
				}
			}
			&.is-open {
				&:after {
					transition: all 200ms;
					width: 0%;
					left: 0;
				}
				&:before {
					transition: all 200ms;
					width: 0%;
					right: 0;
				}
				span {
					transform: rotate(45deg);
					transition: 300ms transform 400ms;
					&:before {
						transform: rotate(-90deg);
						transition: 300ms transform 400ms;
					}
				}
			}
		}
	}

	.menu__button {
		width: ${rem('22px')};
		height: ${rem('18px')};
	}

	@media ${props => props.theme.breakpointLarge} {
		display: none;
	}
`;

MenuButton.defaultProps = {
	className: ``,
};

MenuButton.propTypes = {
	onClick: PropTypes.func,
	className: PropTypes.string,
};

export default MenuButton;



// WEBPACK FOOTER //
// ./src/components/ui/navigation/header/menu-button.jsx